import {gql} from "@apollo/client";
import {ApolloClientQuery} from "./_setup";

const GET_ICON_LISTING = gql`
    query getIconList {
        getIconList {
            ... on IconListArray {
               data{
                   name
                   type
                   label
                   countryCode
                   iconLightActive{
                       path
                   }
                   iconLightInactive{
                       path
                   }
                   iconDarkActive{
                       path
                   }
                   iconDarkInactive{
                       path
                   }
                   defaultIconLightActive{
                       path
                   }
                   defaultIconLightInactive{
                       path
                   }
                   defaultIconDarkActive{
                       path
                   }
                   defaultIconDarkInactive{
                       path
                   }
               }
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;
export async function getIconList() {

    const variables = {
        context: {
            headers: {
                authorization: "Bearer " + localStorage.getItem("a_t"),
            },
        },
    };
    const execute = await ApolloClientQuery(GET_ICON_LISTING, variables, false);

    return execute;
}
